import { useEffect, useState } from 'react';

import { ClientDemographicData } from '../../../../interfaces/entity-dashboard/ClientDemographicData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';
import { DEFAULT_AGE_RANGES } from '../../../../constants/ageRanges';

type UseClientDemographicDataParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

type UseClientDemographicDataReturn = {
  clientDemographicData: ClientDemographicData | null;
};

export const useClientDemographicData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseClientDemographicDataParams): UseClientDemographicDataReturn => {
  const [clientDemographicData, setClientDemographicData] =
    useState<ClientDemographicData | null>(null);

  const fetchClientDemographicData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getClientDemographic({
      ...dateRange,
      solutionType: solutionTypeFilter,
      ageRanges: DEFAULT_AGE_RANGES,
    });

    setClientDemographicData(data);
  };

  useEffect(() => {
    fetchClientDemographicData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { clientDemographicData };
};
